// extracted by mini-css-extract-plugin
export var base = "_2o-0";
export var updateBanner = "_2o-1";